exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._12mkY{background-color:#fcfcfc;height:44px;border:1px solid #dedede!important;line-height:26px;width:214px;text-align:center;font-family:Roboto\\, Light}._12mkY,._12mkY:hover{color:#333}._2VYe3{border-top:3px solid #f20000!important;font-family:Roboto\\, Medium;width:214px;text-align:center}._279hi{border-top:3px solid transparent!important}", ""]);

// exports
exports.locals = {
	"navItemLink": "_12mkY",
	"active": "_2VYe3",
	"inactive": "_279hi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Tabs/Tab.css
// module id = 1344
// module chunks = 0 1